var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKoinIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4540_121675",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 37
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6035,
    cy: 18.5,
    r: 17.6035,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4540_121675)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.928 30.8852C36.7336 24.0795 36.7336 13.0455 29.928 6.23984C23.1223 -0.565785 12.0882 -0.565784 5.28263 6.23984C-1.52299 13.0455 -1.52299 24.0795 5.28263 30.8852C12.0882 37.6908 23.1223 37.6908 29.928 30.8852Z",
    fill: "url(#paint0_linear_4540_121675)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2805 30.2397C35.7296 23.7905 35.7296 13.3345 29.2805 6.88535C22.8314 0.436237 12.3753 0.436237 5.92617 6.88535C-0.522939 13.3345 -0.522939 23.7905 5.92617 30.2397C12.3753 36.6888 22.8314 36.6888 29.2805 30.2397Z",
    fill: "url(#paint1_linear_4540_121675)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M14.8682 32.9518C8.13744 31.6745 3.0096 25.773 2.95647 18.6683C2.89628 10.591 9.41877 3.97076 17.4961 3.91057C21.4091 3.88161 25.0989 5.37775 27.8862 8.124C30.6735 10.8702 32.2248 14.5374 32.254 18.4502C32.283 22.3629 30.7868 26.0528 28.0406 28.8403C25.2944 31.6276 21.6274 33.1787 17.7144 33.2079C16.7418 33.2152 15.7899 33.1268 14.8682 32.952V32.9518ZM20.2282 4.89398C19.339 4.72525 18.4271 4.6424 17.5014 4.6492C13.7861 4.6769 10.3037 6.14962 7.69598 8.79664C5.08824 11.4434 3.66739 14.9474 3.6951 18.6627C3.7228 22.3783 5.19577 25.8604 7.84254 28.4681C10.4896 31.0756 13.9928 32.4964 17.7089 32.4687C21.4242 32.441 24.9065 30.9683 27.5143 28.3213C30.1218 25.6745 31.5428 22.1708 31.5149 18.4552C31.4872 14.7399 30.0145 11.2576 27.3675 8.64982C25.38 6.69182 22.9087 5.40268 20.228 4.89373L20.2282 4.89398Z",
    fill: "url(#paint2_linear_4540_121675)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.792 14.2973C11.792 13.8914 12.1219 13.5625 12.5289 13.5625H16.8025C17.2094 13.5625 17.5393 13.8916 17.5393 14.2973V26.057C17.5393 26.4629 17.2094 26.7918 16.8025 26.7918H12.5289C12.1219 26.7918 11.792 26.4627 11.792 26.057V14.2973Z",
    fill: "#E1BE32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1802 12.1931C18.1802 11.6249 18.6421 11.1641 19.2117 11.1641H25.3345C26.253 11.1641 26.7136 12.2711 26.0648 12.9196L19.9415 19.0427C19.292 19.6922 18.1797 19.2333 18.1797 18.3159V12.1928L18.1802 12.1931Z",
    fill: "#E1BE32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1861 27.0491C19.7791 27.0491 19.4492 26.72 19.4492 26.3143V22.2462C19.4492 21.5954 20.2349 21.2658 20.7013 21.7206L24.8719 25.7887C25.3441 26.2493 25.0173 27.0491 24.3567 27.0491H20.1861Z",
    fill: "#E1BE32"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2904 25.1274C19.3279 24.8265 10.9286 18.3081 7.84085 9.32031C5.56883 11.7244 4.17578 14.9679 4.17578 18.5368C4.17578 25.9489 10.1845 31.9576 17.5966 31.9576C22.6135 31.9576 26.9874 29.2049 29.2904 25.1274Z",
    fill: "url(#paint3_linear_4540_121675)",
    fillOpacity: 0.3
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.792 13.4516C11.792 13.0457 12.1219 12.7168 12.5289 12.7168H16.8025C17.2094 12.7168 17.5393 13.0459 17.5393 13.4516V25.2113C17.5393 25.6172 17.2094 25.9461 16.8025 25.9461H12.5289C12.1219 25.9461 11.792 25.617 11.792 25.2113V13.4516Z",
    fill: "#A85D14"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1802 11.3474C18.1802 10.7792 18.6421 10.3184 19.2117 10.3184H25.3345C26.253 10.3184 26.7136 11.4254 26.0648 12.0739L19.9415 18.197C19.292 18.8464 18.1797 18.3876 18.1797 17.4702V11.3471L18.1802 11.3474Z",
    fill: "#A85D14"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1861 26.2034C19.7791 26.2034 19.4492 25.8743 19.4492 25.4686V21.4005C19.4492 20.7497 20.2349 20.4201 20.7013 20.8749L24.8719 24.943C25.3441 25.4036 25.0173 26.2034 24.3567 26.2034H20.1861Z",
    fill: "#A85D14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4540_121675",
    x1: -4.60348,
    y1: 3.46803,
    x2: 47.7827,
    y2: 39.0733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C68A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B47C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AA731E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AF781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DEA731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F0D257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FDF173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7E267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#E2A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4540_121675",
    x1: 5.87373,
    y1: 30.4686,
    x2: 32.4847,
    y2: 3.45538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.220876,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543048,
    stopColor: "#F0D257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7E267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#E2A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4540_121675",
    x1: 3.21086,
    y1: 15.8248,
    x2: 31.9995,
    y2: 21.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C68A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B47C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AA731E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AF781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DEA731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F0D257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FDF173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7E267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#E2A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4540_121675",
    x1: 24.0104,
    y1: 13.7301,
    x2: 9.78898,
    y2: 28.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2B4",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoinIcons);
export default __webpack_public_path__ + "static/media/koin-icons.8fe1c535905af742da8bd562365382ef.svg";
export { ForwardRef as ReactComponent };